module.exports = __webpack_public_path__ + "img/der_01_xrobot.6eef337f.png";